import {Injectable} from '@angular/core';
import {CanDeactivate} from '@angular/router';
import {Observable} from 'rxjs';
import {NotificationService} from '../services/notification.service';

/**
 * Lo implementa cada componente ruteado que tenga un formulario. Un componente
 * que embebe formularios (la actividad con su listado de asuntos, el detalle con
 * la edición inline) delega en ellos.
 */
export interface ConCambiosSinGuardar {
    hayCambiosSinGuardar(): boolean;
}

/**
 * Frena la navegación cuando hay contenido sin guardar y pregunta antes de
 * perderlo. Existe porque la pérdida más frecuente no era un error del servidor
 * —ese deja el formulario intacto— sino irse sin querer: un clic en el menú, un
 * F5, cerrar la pestaña. Este guard cubre la navegación interna; el aviso ante
 * recarga o cierre lo da cada componente con `window:beforeunload`, que el
 * navegador exige registrar en el propio componente.
 *
 * Usa el diálogo de la app (smartMessageBox) y no window.confirm: es el mismo
 * que ya pregunta "¿Descartar contenido?" al cancelar la actividad, así el
 * usuario ve una sola forma de aviso.
 */
@Injectable()
export class CambiosSinGuardarGuard implements CanDeactivate<ConCambiosSinGuardar> {

    constructor(private notificationService: NotificationService) {}

    canDeactivate(component: ConCambiosSinGuardar): Observable<boolean> | boolean {
        if (!component || typeof component.hayCambiosSinGuardar !== 'function' || !component.hayCambiosSinGuardar()) {
            return true;
        }
        return new Observable<boolean>(observer => {
            this.notificationService.smartMessageBox({
                title: '<i class="fa fa-exclamation-triangle" style="color:yellow"></i>   Cambios sin guardar',
                content: 'Hay contenido que todavía no se guardó. Si sale ahora, se pierde. <b>¿Qué desea hacer?</b>',
                buttons: '[Quedarme][Descartar]'
            }, (botonPresionado) => {
                observer.next(botonPresionado === 'Descartar');
                observer.complete();
            });
        });
    }
}
